import React from "react";
import LegalDocumentView from "../../components/legal/LegalDocumentView";
import { useLegalDocument } from "../../hooks/useLegalDocument";

const PrivacyPolicy: React.FC = () => {
  const legalDocument = useLegalDocument("privacyPolicy");

  return <LegalDocumentView legalDocument={legalDocument} />;
};

export default PrivacyPolicy;
